

require('./styles');

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index'], function ($, angular, squid, template) {

    return angular.module('xo-route-to-complete.directive', ['squid', 'xomodel.checkout']).directive('xoRouteToComplete', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '='
            },

            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate, $locale, $window) {

                /* hide the footer cancel link */
                angular.element('#defaultCancelLink').hide();

                $rootScope.$on('$stateChangeStart', function (event) {
                    event.preventDefault();
                });

                /* hide header paypal logo*/
                $('.paypalHeaderWrapper').hide();

                $('.footerWrapper').addClass('routecss');

                /* urlType is passed from xo-end or from xo-page-components/footer/directive.
                 * urltype can be either success(incase of successfull flow completion ) or cancel
                 * */
                var urlType = $stateParams.urlType;

                // show the return to merchant url only in case of success.
                if (urlType === 'success') {
                    $scope.enableSuccessReturnUrl = true;
                }

                if (urlType === 'cancel') {
                    // defaulting to False. Once the cancel content is available, turn it to true.
                    $scope.enableCancelReturnUrl = true;
                }

                $scope.goToMerchant = function () {
                    $window.onunload = $window.onbeforeunload = function () {};
                    $window.location = $stateParams.url;
                };

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                }).then(function () {
                    var merchant = $scope.checkoutAppData.merchant;
                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
                });

                $scope.$on('$destroy', function (event) {
                    $('.paypalHeaderWrapper').show();
                    $('.footerWrapper').removeClass('routecss');
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/route-to-complete/directive.js
// module id = ./components/xo-page-components/src/route-to-complete/directive.js
// module chunks = 1